import { render, staticRenderFns } from "./TermsOfBusinessAP.vue?vue&type=template&id=686574a4&scoped=true&"
import script from "./TermsOfBusinessAP.vue?vue&type=script&lang=js&"
export * from "./TermsOfBusinessAP.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfBusinessAP.vue?vue&type=style&index=0&id=686574a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686574a4",
  null
  
)

export default component.exports